import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { MoveStagedAliquotInput, MoveStagedAliquotResponse } from '../../core/api/lab.types';

/* Create new CryoBox */
export const moveStagedAliquotThunk = createAsyncThunk(
  'shipment/moveStagedAliquot',
  async (values: MoveStagedAliquotInput, { rejectWithValue }: any) => {
    const response: MoveStagedAliquotResponse = await labApi.moveStagedAliquot(values);
    if (response.data?.moveStagedAliquot) {
      return response.data?.moveStagedAliquot;
    }
    return rejectWithValue(response.errors);
  },
);
